import React from 'react';
import { ShoppingCart, CreditCard, Rocket } from 'lucide-react';

const ChatGPTSteps = () => {
  const steps = [
    {
      number: '1',
      icon: <ShoppingCart />,
      title: 'Choose Your Package',
      description: 'Browse our curated selection of AI services and select the perfect plan for your needs.'
    },
    {
      number: '2',
      icon: <CreditCard />,
      title: 'Secure Checkout',
      description: 'Complete your purchase through our encrypted payment system. Takes less than 60 seconds.'
    },
    {
      number: '3',
      icon: <Rocket />,
      title: 'Start Using',
      description: 'Receive your login credentials via email and access your premium AI services immediately.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Get Started in 3 Simple Steps
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Access premium AI services in under 60 seconds
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative inline-block mb-8">
                <div className="w-20 h-20 border-2 border-black rounded-full flex items-center justify-center bg-white">
                  <span className="text-2xl font-bold text-gray-900">{step.number}</span>
                </div>
                <div className="absolute -bottom-2 -right-2 bg-black text-white p-2 rounded-full">
                  {step.icon}
                </div>
              </div>
              
              <h3 className="text-2xl font-semibold mb-4 text-gray-900">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <p className="text-xl font-semibold text-gray-900">
            Simple. Fast. Secure.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ChatGPTSteps;